module.exports = __webpack_public_path__ + "assets/img/detail18.d942f711.png";